import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "holiday-container mb-32" }
const _hoisted_2 = { class: "flex justify-start w-full mgb-16" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_4 = { class: "table-role-list w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Button, { class: "btn-light-blue w-30 h-10 mb-6" }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers
      }, null, 8, ["data", "headers"])
    ])
  ]))
}